import '@atlassian/soy-template-plugin-js/dist/js/atlassian-deps.js';
import '@atlassian/soy-template-plugin-js/dist/js/soyutils.js';

import '../src/aui.soy';
import '../src/avatar.soy';
import '../src/badges.soy';
import '../src/banner.soy';
import '../src/buttons.soy';
import '../src/dialog2.soy';
import '../src/dropdown2.soy';
import '../src/expander.soy';
import '../src/form.soy';
import '../src/group.soy';
import '../src/icons.soy';
import '../src/inline-dialog2.soy';
import '../src/labels.soy';
import '../src/lozenges.soy';
import '../src/message.soy';
import '../src/navigation.soy';
import '../src/page.soy';
import '../src/panel.soy';
import '../src/progress-tracker.soy';
import '../src/sidebar.soy';
import '../src/table.soy';
import '../src/tabs.soy';
import '../src/toolbar2.soy';
import '../src/trigger.soy';

export default window.aui;
